/** Teks tabel "Log penggunaan penyedia" (v2/M5) di /admin/ai-assistant/pemakaian. */
export interface AssistantUsageLogText {
	title: string;
	intro: string;
	privacyNote: string;
	rangeLabel: string;
	rangeOption: (days: number) => string;
	vendorLabel: string;
	statusLabel: string;
	all: string;
	vendorClaude: string;
	vendorChatgpt: string;
	vendorUnknown: string;
	statusOk: string;
	statusError: string;
	summaryTitle: string;
	summaryShare: (percent: string) => string;
	summaryTurns: (n: string) => string;
	summaryErrors: (n: string) => string;
	summaryTokens: (input: string, output: string) => string;
	summaryEmpty: string;
	colTime: string;
	colVendor: string;
	colModel: string;
	colLatency: string;
	colInput: string;
	colOutput: string;
	colStatus: string;
	colKind: string;
	kindText: string;
	kindVoice: string;
	modelUnknown: string;
	loading: string;
	empty: string;
	loadFailed: string;
	loadMore: string;
}

const id: AssistantUsageLogText = {
	title: "Log penggunaan penyedia",
	intro:
		"Penyedia yang BENAR-BENAR menjawab tiap giliran chat: Claude (profil Utama) atau ChatGPT (profil Cadangan). Giliran yang gagal dijawab ikut tercatat.",
	privacyNote:
		"Hanya metadata. Isi percakapan dan identitas penanya tidak pernah ditampilkan di sini. Log ikut terhapus bersama percakapannya.",
	rangeLabel: "Rentang",
	rangeOption: (days) => (days === 1 ? "Hari ini" : `${days} hari terakhir`),
	vendorLabel: "Penyedia",
	statusLabel: "Status",
	all: "Semua",
	vendorClaude: "Claude",
	vendorChatgpt: "ChatGPT",
	vendorUnknown: "Tidak diketahui",
	statusOk: "Terjawab",
	statusError: "Gagal",
	summaryTitle: "Ringkasan rentang ini",
	summaryShare: (percent) => `${percent}% giliran`,
	summaryTurns: (n) => `${n} giliran`,
	summaryErrors: (n) => `${n} gagal`,
	summaryTokens: (input, output) => `${input} masuk / ${output} keluar`,
	summaryEmpty: "Belum ada giliran pada rentang ini.",
	colTime: "Waktu",
	colVendor: "Penyedia",
	colModel: "Model",
	colLatency: "Latensi",
	colInput: "Token masuk",
	colOutput: "Token keluar",
	colStatus: "Status",
	colKind: "Jenis",
	kindText: "Teks",
	kindVoice: "Suara",
	modelUnknown: "tidak diketahui",
	loading: "Memuat log…",
	empty: "Belum ada giliran yang tercatat pada rentang dan filter ini.",
	loadFailed: "Log penggunaan tidak dapat dimuat.",
	loadMore: "Muat lebih banyak",
};

const en: AssistantUsageLogText = {
	title: "Provider usage log",
	intro:
		"Which provider ACTUALLY answered each chat turn: Claude (Primary profile) or ChatGPT (Backup profile). Turns that failed to get an answer are logged too.",
	privacyNote:
		"Metadata only. Message content and the identity of whoever asked are never shown here. The log is deleted together with its conversation.",
	rangeLabel: "Range",
	rangeOption: (days) => (days === 1 ? "Today" : `Last ${days} days`),
	vendorLabel: "Provider",
	statusLabel: "Status",
	all: "All",
	vendorClaude: "Claude",
	vendorChatgpt: "ChatGPT",
	vendorUnknown: "Unknown",
	statusOk: "Answered",
	statusError: "Failed",
	summaryTitle: "Summary for this range",
	summaryShare: (percent) => `${percent}% of turns`,
	summaryTurns: (n) => `${n} turns`,
	summaryErrors: (n) => `${n} failed`,
	summaryTokens: (input, output) => `${input} in / ${output} out`,
	summaryEmpty: "No turns in this range yet.",
	colTime: "Time",
	colVendor: "Provider",
	colModel: "Model",
	colLatency: "Latency",
	colInput: "Input tokens",
	colOutput: "Output tokens",
	colStatus: "Status",
	colKind: "Kind",
	kindText: "Text",
	kindVoice: "Voice",
	modelUnknown: "unknown",
	loading: "Loading log…",
	empty: "No turns recorded for this range and filter yet.",
	loadFailed: "The usage log could not be loaded.",
	loadMore: "Load more",
};

export const assistantUsageLogTexts = { id, en } as const;
